namespace SPA
{
	export namespace Organization
	{
		export namespace gui
		{
			export class EmployeeEntry extends AbstractEntry
			{

				private m_Employee:	Wollmilch.EmployeeObject;

				public constructor( obj: Wollmilch.EmployeeObject, orga: OrgaTree )
				{
					super( orga );

					this.m_Employee	= obj;

					this.clearTitle();
				}

				public rebuild( root?: ui.base.BaseHTMLElement<HTMLElement> | JQuery<HTMLElement> ): EmployeeEntry
				{
					super.rebuild( root );

					this.buildBasicInfo();
					new SPA.gui.view.AccountView( this.m_Employee ).rebuild( this );

					return this;
				}

				private buildBasicInfo()
				{
					ui.$$.div()
						.appendTo(this.Root())
						.append('<h2>Organisation - Mitarbeiter</h2>')
						.append(
							new SPA.gui.address.AddressSection(this.m_Employee, this.m_Orga).rebuild().Root()
						);
				}
			}
		}
	}
}
